
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/favorites",
      function () {
        return require("private-next-pages/account/favorites/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/favorites"])
      });
    }
  